class CartRecommendations extends HTMLElement {
	observer = undefined;

	constructor() {
		super();
	}

	connectedCallback() {
		this.initializeRecommendations(this.dataset.productId);
	}

	initializeRecommendations(productId) {
		this.observer?.unobserve(this);
		this.observer = new IntersectionObserver(
			(entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);
				this.loadRecommendations(productId);
			},
			{ rootMargin: '0px 0px 400px 0px' }
		);
		this.observer.observe(this);		
	}

	initSwiper() {
		const swiperElement = this.querySelector('swiper-container');
		if (!swiperElement) {
			return;
		}

		const swiperConfig = {
			slidesPerView: 'auto',
			spaceBetween: 16,
			grabCursor: true,
			slidesOffsetBefore: 16,
			slidesOffsetAfter: 16,
			scrollbar: {
				draggable: true,
			}
		};
		Object.assign(swiperElement, swiperConfig);
		swiperElement.initialize();
	}

	loadRecommendations(productId) {
		fetch(`${this.dataset.url}&product_id=${productId}&section_id=cart-recommendations`)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('cart-recommendations');
				if (recommendations?.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
				}
				this.initSwiper();
			})
			.catch((e) => {
				console.error(e);
				console.log('ERROR loading Recommendations', e);
			});
	}
}

customElements.define('cart-recommendations', CartRecommendations);
